export var OUR_OFFICE_LOCATIONS = [
    "London",
    "New York",
    "San Francisco",
    "São Paulo",
    "Toronto",
    "Waterloo"
];
